import { Stat } from "@/design/components";

export type MoneyStripItem = { label: string; value: string };

/**
 * The standardised KPI row (Trace Source spec §3.5, "Money strip") — no
 * single component of this shape exists in the design system yet, so this
 * is a thin composition over the existing Stat primitive rather than a new
 * component from scratch.
 */
export function TraceMoneyStrip({ items }: { items: MoneyStripItem[] }) {
  if (items.length === 0) return null;
  return (
    // flex, not a fixed grid-cols-4 — this strip usually holds just the one
    // headline figure; a rigid 4-column grid left three empty cells.
    <div className="flex flex-wrap gap-3 rounded-lg bg-subtle p-3">
      {items.map((it) => (
        <Stat key={it.label} label={it.label} value={it.value} className="min-w-[140px] border-0 bg-transparent p-0" />
      ))}
    </div>
  );
}
